import * as R from "ramda";

export const LIKE_PERMISSION = "like";
export const LIKE_SCREENING_RESTRICTED_PERMISSION = "processOnly";

const CANDIDATE_SELECTION_PERMISSIONS = [
  LIKE_PERMISSION,
  LIKE_SCREENING_RESTRICTED_PERMISSION
];

const withoutCandidateSelectionPermissions = R.reject(permission =>
  CANDIDATE_SELECTION_PERMISSIONS.includes(permission)
);

export const getCandidateSelectionPermissionMode = (permissions = []) => {
  if (permissions.includes(LIKE_SCREENING_RESTRICTED_PERMISSION)) {
    return LIKE_SCREENING_RESTRICTED_PERMISSION;
  }

  if (permissions.includes(LIKE_PERMISSION)) {
    return LIKE_PERMISSION;
  }

  return null;
};

export const setCandidateSelectionPermissionEnabled = (
  permissions = [],
  enabled,
  fallbackMode = LIKE_PERMISSION
) => {
  const normalizedPermissions = R.defaultTo([], permissions);
  const candidateSelectionPermission =
    getCandidateSelectionPermissionMode(normalizedPermissions) || fallbackMode;

  return R.uniq([
    ...withoutCandidateSelectionPermissions(normalizedPermissions),
    ...(enabled && candidateSelectionPermission
      ? [candidateSelectionPermission]
      : [])
  ]);
};

export const setCandidateSelectionPermissionMode = (
  permissions = [],
  mode = LIKE_PERMISSION
) => {
  return R.uniq([
    ...withoutCandidateSelectionPermissions(R.defaultTo([], permissions)),
    ...(mode === LIKE_SCREENING_RESTRICTED_PERMISSION
      ? [LIKE_SCREENING_RESTRICTED_PERMISSION]
      : [LIKE_PERMISSION])
  ]);
};

export const getInviteUserFormPermissions = permissions => {
  const normalizedPermissions = R.defaultTo([], permissions);
  const candidateSelectionPermission = getCandidateSelectionPermissionMode(
    normalizedPermissions
  );

  return R.uniq([
    ...withoutCandidateSelectionPermissions(normalizedPermissions),
    ...(candidateSelectionPermission ? [candidateSelectionPermission] : [])
  ]);
};

export const normalizeOpportunityUserPermissions = permissions => {
  const normalizedPermissions = R.defaultTo([], permissions);
  const candidateSelectionPermission = getCandidateSelectionPermissionMode(
    normalizedPermissions
  );

  return R.uniq([
    ...withoutCandidateSelectionPermissions(normalizedPermissions),
    ...(candidateSelectionPermission === LIKE_PERMISSION
      ? [LIKE_PERMISSION]
      : []),
    ...(candidateSelectionPermission === LIKE_SCREENING_RESTRICTED_PERMISSION
      ? [LIKE_PERMISSION, LIKE_SCREENING_RESTRICTED_PERMISSION]
      : [])
  ]);
};

export const getOpportunityUserDisplayPermissions = permissions => {
  const normalizedPermissions = R.defaultTo([], permissions);
  const candidateSelectionPermission = getCandidateSelectionPermissionMode(
    normalizedPermissions
  );

  return [
    ...withoutCandidateSelectionPermissions(normalizedPermissions),
    ...(candidateSelectionPermission ? [candidateSelectionPermission] : [])
  ];
};
